import React, { useEffect } from "react"
import { BrowserRouter as Router, Switch } from "react-router-dom"

import { authProtectedRoutes, publicRoutes } from "./routes"

import Authmiddleware from "./routes/route"

import NonAuthLayout from "./components/NonAuthLayout"
import VerticalLayout from "./components/VerticalLayout"

import moment from "moment"
import "moment/locale/pt-br"
import "./assets/scss/theme.scss"
import { registerLocale, setDefaultLocale } from "react-datepicker"
import ptBR from "date-fns/locale/pt-BR/index.js"
import { layoutModeTypes, useLayoutStore } from "store/useLayoutStore"

const App = props => {
  moment.locale("pt-br")
  registerLocale("pt-br", ptBR)
  setDefaultLocale("pt-br")

  const setLayoutModeType = useLayoutStore(state => state.setLayoutModeType)

  useEffect(() => {
    if (!localStorage.getItem("theme")) {
      localStorage.setItem("theme", layoutModeTypes.LIGHT)
    } else {
      setLayoutModeType(localStorage.getItem("theme"))
    }
  }, [])

  return (
    <React.Fragment>
      <Router>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={VerticalLayout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              requiredRoles={route.requiredRoles}
              exact={route.exact}
            />
          ))}
        </Switch>
      </Router>
    </React.Fragment>
  )
}

export default App
